export default {
  bannersHome: [],
};
